import { axiosInstance } from "./config";

export const getAllVendors = async () => {
  try {
    const res = await axiosInstance.get("/employees");
    const all = Array.isArray(res.data) ? res.data : [];
    return all.filter((u) => (u.role || "").toLowerCase() === "vendor");
  } catch (error) {
    console.error("Failed to fetch vendors:", error);
    return [];
  }
};

export const createVendor = async (data) => {
  const res = await axiosInstance.post("/admin/employees", {
    ...data,
    role: "vendor",
  });
  return res.data;
};

export const updateVendor = async (id, data) => {
  const res = await axiosInstance.post(`/employees/${id}`, {
    ...data,
    role: "vendor",
  });
  return res.data;
};

export const deleteVendor = async (id) => {
  const res = await axiosInstance.delete(`/employees/${id}`);
  return res.data;
};
